const DEFAULT_CONFIG = {
	//标题
	APP_NAME: '',

	//跳转地址
	hrefApi: 'https://videoapi.hxjpayment.cn',

	//线上地址
	// API_URL: 'https://humandev.hxjpayment.cn',
	API_URL: 'https://humanapi.hxjpayment.cn',

	// 本地调试
	//   API_URL: 'http://192.168.0.145:9511',
    
	//请求超时
	TIMEOUT: 60000,

	//TokenName
	TOKEN_NAME: "Authorization",

	//Token前缀，注意最后有个空格，如不需要需设置空字符串
	TOKEN_PREFIX: "Bearer ",

};

export default DEFAULT_CONFIG;